<template lang="pug">
    Page.residentials
        .residentials__top(
            slot="header"
        )
            h1.residentials__title
                | Районы

            .residentials__subheader
                SvInput.residentials__search(
                    v-model="search"
                    placeholder="Введите название района"
                    color="gray"
                    size="large"
                )

                SvButton.residentials__add(
                    view="big"
                    text="Добавить"
                    :prependIcon=`{
                    icon: 'plus',
                    width: 17,
                    height: 17,
                    fillDefault: '#fff',
                    fillHover: '#fff'
                }`
                    @click="transfer('new')"
                )

        SvTable.residentials__table(
            :headers="headers"
            :body="list"
            @transfer="(el) => transfer(el.id)"
        )
</template>

<script>
import {mapGetters} from 'vuex';
import Page from '@/layouts/page.vue';
import SvInput from '@/components/uikit/SvInput.vue';
import SvButton from '@/components/uikit/SvButton.vue';
import SvTable from '@/components/uikit/SvTable.vue';

export default {
    name: "Districts",

    components: {
        Page,
        SvInput,
        SvButton,
        SvTable,
    },

    beforeMount() {
        this.$store.dispatch('districts/getList');
    },

    data() {
        return {
            headers: [
                {
                    title: 'Название',
                    path: 'name',
                    width: '40%',
                },
                {
                    title: 'Символьный код',
                    path: 'alias',
                    width: '30%',
                },
                {
                    title: 'Дата изменения',
                    path: 'updated_at',
                    width: '15%',
                },
                {
                    title: 'Аквтивность',
                    path: 'is_active',
                    width: '15%',
                },
            ],
        };
    },

    computed: {
        ...mapGetters({
            list: 'districts/getList',
        }),

        search: {
            get() {
                return this.$store.state.digital.search;
            },

            set(search) {
                this.$store.commit('districts/setSearch', search);
            },
        },
    },

    methods: {
        transfer(id) {
            this.$router.push({
                name: 'district-edit',
                params: {
                    id,
                },
            });
        },
    },
}
</script>

<style lang="scss" scoped>
.residentials__title {
    margin: 10px 0 19px 0;
    font-size: 46px;
    font-weight: 500;
    color: #404450;
}

.residentials__subheader {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.residentials__search {
    width: 47%;
    min-width: 280px;
}

.residentials__table {
    margin-top: 30px;
}
</style>
